var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatteryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 65,
    viewBox: "0 0 38 65",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1408 0C11.484 0 10.1408 1.34315 10.1408 3V4.50704H8C3.58172 4.50704 0 8.08876 0 12.507V56.7887C0 61.207 3.58172 64.7887 8 64.7887H29.1831C33.6014 64.7887 37.1831 61.207 37.1831 56.7887V12.507C37.1831 8.08877 33.6014 4.50704 29.1831 4.50704H27.0423V3C27.0423 1.34315 25.6991 0 24.0423 0H13.1408Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryIcon);
export default __webpack_public_path__ + "static/media/battery-icon.76dae06c701cb6c7aa056a08f49034a2.svg";
export { ForwardRef as ReactComponent };